import { Icon } from '@ur-solutions/react-components'
import { TimeAddons } from './TimeAddons'
import { useForm, useTranslate } from '@ur-solutions/react-hooks'
import styled from 'styled-components'
import { TimeOverrides } from './TimeOverrides'
import { FixedAddons } from './FixedAddons'
import { H2 } from '@/components'

const Wrapper = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 1rem 0;

  h2 {
    grid-column: 1 / -1;
    display: flex;
    width: 100%;

    margin: 1rem 0 0 8px;
    font-weight: 600;

    div {
      margin-left: 1rem;
    }

    cursor: default;
  }
`

interface AddonOverviewProps {
  userId: string
  datetimeStart: Date
  datetimeEnd: Date
  onChange?: () => void
}

export const AddonOverview: React.JSX.CFC<AddonOverviewProps> = ({
  userId,
  datetimeStart,
  datetimeEnd,
  onChange,
}) => {
  const translations = useTranslate({
    salaryConfiguration: 'salary.configuration',
    addonsAndChange: 'salary.addons-and-change',
  })

  const { formValues: filter, formChangeHandler: handler } = useForm({
    values: {
      open: false,
    },
    config: {
      storage: {
        storeFormState: true,
        sessionStorage: true,
        retrieveFormStateOnMount: true,
        storeFormStateName: 'firmadok__activities-salary-open-filter',
        transformValues: {
          open: value => {
            return typeof value === 'boolean' ? value : false
          },
        },
      },
    },
  })
  return (
    <Wrapper id="addon-overview">
      <H2 onClick={() => handler('open')(!filter.open)}>
        {translations.addonsAndChange}

        <Icon
          icon={filter.open ? 'chevron-down' : 'chevron-left'}
          size="1.25rem"
          margin="0.25rem 0 0 1rem"
        />
      </H2>

      {filter.open && (
        <>
          <TimeAddons
            datetimeStart={datetimeStart}
            datetimeEnd={datetimeEnd}
            userId={userId}
            onChange={onChange}
          />

          <TimeOverrides
            datetimeStart={datetimeStart}
            datetimeEnd={datetimeEnd}
            userId={userId}
            onChange={onChange}
          />

          <FixedAddons
            datetimeStart={datetimeStart}
            datetimeEnd={datetimeEnd}
            userId={userId}
            onChange={onChange}
          />
        </>
      )}
    </Wrapper>
  )
}
